<template>
  <v-container>
    <v-dialog
      v-model="privacy"
      persistent
      max-width="600px"
      transition="dialog-transition">
      <v-card>
        <v-toolbar color="primary" dark dense>
          <img 
            src="@/assets/nihr-logo.svg" 
            alt="National Institute for Health and Care Research"
            width="160">
          <v-toolbar-title class="title">Privacy policy</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <p class="text-xs-left body-2 font-weight-medium"> {{privacyPolicy.policy}} </p>
          <p class="text-xs-left body-2 font-weight-medium">{{privacyPolicy.contactText}} <a :href="targetEmail" target='_blank'>{{privacyPolicy.contactEmail}}</a>  </p>
        </v-card-text>  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            flat 
            outline
            @click="privacy = !privacy">
              Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      fixed
      app
    >
      <v-list dense>
        <v-list-tile 
                    :to="{name: 'welcome'}"
                    ripple>
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile 
                    :to="{name: 'search'}"
                    ripple>
          <v-list-tile-action>
            <v-icon>search</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Search</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile 
                    :to="{name: 'userProfile'}"
                    ripple>
          <v-list-tile-action>
            <v-icon>account_box</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>My Profile</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile 
                    :to="{name: 'relationships'}"
                    ripple>
          <v-list-tile-action>
            <v-icon>group</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>My relationships</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-group
                    prepend-icon="settings"
                    value="false"
                    v-if="isAdmin">
          <v-list-tile slot="activator">
            <v-list-tile-title>Admin</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
                    :to="{name: 'mentoradmin'}"
                    ripple>
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Mentor admin</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>how_to_reg</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
                    :to="{name: 'clientadmin'}"
                    ripple>
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Client admin</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>how_to_reg</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
                    :to="{name: 'reladmin'}"
                    ripple>
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Relationship overview</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
                    :to="{name: 'mentorreport'}"
                    ripple>
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Mentor report</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile 
                    :to="{name: 'configadmin'}"
                    ripple>
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Configuration update</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>build</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile 
                    :to="{name: 'adminemail'}"
                    ripple>
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Authorisation admin</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>build</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile 
                    :to="{name: 'welcomeadmin'}"
                    ripple>
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Welcome page text</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>edit</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile 
                    :to="{name: 'privacyadmin'}"
                    ripple>
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-title>Privacy Policy</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>policy</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="primary" dark app fixed clipped-left>
      <v-toolbar-side-icon 
        aria-label="Side navigator show/hide"
        @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <img 
        src="@/assets/nihr-logo.svg" 
        alt="National Institute for Health and Care Research"
        width="190"
        >
      <v-toolbar-title><h1 class="title">{{appTitle}}</h1></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-divider vertical></v-divider>
      <v-btn flat :href="configData.userGuideURL" target="_blank">User Guides</v-btn>
      <v-divider vertical></v-divider>
      <v-btn flat @click.native="logOut">Sign Out</v-btn>
      <span>{{displayUser}}</span>
    </v-toolbar>
    <!-- Busy progress bar -->
    <v-dialog
      v-model="storeLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            :color=progressColour
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Display Error in a snackbar -->
    <v-snackbar
                v-model="errorMessage.display"
                :color="errorMessage.color"
                :timeout=3000
                top
                vertical>
      {{errorMessage.message}}
      <v-btn
              dark
              flat
              @click="clearError">
        Close
      </v-btn>
    </v-snackbar>
  <!-- Start of where the actual pages go -->
    <div>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  <!-- End of where the actual pages go #ACBCC3 -->
    <v-footer 
            app
            inset 
            color="#EFF1F3"
            height="auto">
      <v-layout justify-end row wrap>
        <v-spacer></v-spacer>
        <!-- <span style="color:#ACBCC3">&copy; {{thisYear}} CRN North East and North Cumbria&nbsp;</span> -->
        <div style="color:#193E72" class="pt-2">&copy; {{thisYear}} CRN North East and North Cumbria&nbsp;</div>
        <v-spacer></v-spacer>
        <v-btn 
          color="primary"
          flat
          small
          @click="privacy = !privacy">
          Privacy Policy
        </v-btn>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/auth';

  export default {
    name: 'navigation',
    data: () => ({
      drawer: null,
      mini: false,
      dialog: false,
      privacy: false
    }),
    props: {
      source: String
    },
    mounted() {
      this.dialog = true
    },
    computed: {
      displayUser: function () {
        return this.$store.getters.getUserEmail
      },
      storeLoading: function () {
        return this.$store.getters.getStoreLoading
      },
      progressColour: function() {
        return this.$store.getters.getProgressColour
      },
      errorMessage: function () {
        return this.$store.getters.getErrorMessage
      },
      configData: function () {
        // get the configuration data from the store
        return this.$store.getters.getConfig
      },
      appTitle: function () {
        // get the configuration data from the store
        return this.$store.getters.getAppTitle
      },
      isAdmin: function () {
        return this.$store.getters.getAdminFlag
      },
      thisYear: function() {
        return new Date().getFullYear()
      },
      privacyPolicy: function() {
        return this.$store.getters.getPrivacyPolicy
      },
      targetEmail: function () {
        return "mailto: "+this.privacyPolicy.contactEmail
      }
    },
    watch: {
      dialog (val) {
        if (!val) return
        setTimeout(() => (this.dialog = false), 4000)
      }
    },
    methods: {
      logOut: function() {
        firebase.auth().signOut()
          .then(() => {
            this.$router.push('/')
          })
      },
      clearError() {
        this.$store.commit("clearErrorMessage")
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slidefade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
  p {
    white-space: pre-line;
  }

</style>